import title from '../video_assets/blume.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/245/2459051/,2459051_35926838,2459051_35926839,2459051_35926840,2459051_35926836,2459051_35926841,2459051_35926837,.mp4.csmil/master.m3u8'

export default {
  id: '05',
  name: 'Blumen-Memo (Musik 5/5)',
  subtitle: 'Programmiere ein Computer-Spiel mit Tönen',
  image: title,
  video: url,
}
